import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import Cart from '../Cart/Cart';
import { Badge } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getCartProduct } from '../../Redux/CartRedux';

const activeStyle = {
  fontWeight: 'bold',
  color: 'var(--primary-color)',
  borderBottom: '2px solid var(--primary-color)',
};

const hoverStyle = {
  color: 'var(--primary-color)',
  borderBottom: '2px solid var(--primary-color)',
};

function Navbar() {
  const location = useLocation();
  const dispatch = useDispatch();
  const isAuthenticated = !!sessionStorage.getItem('authenticated');
  const { cartProducts } = useSelector((state) => state.cartRedux);

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [cart, setCart] = useState(0);

  const isMobile = useMediaQuery('(max-width: 991px)');
  const userId =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).userId;
  const navData = [
    { name: 'Home', title: 'Home', link: '/' },
    { name: 'Products', title: 'Products', link: '/products' },
    { name: 'Entrepreneurs', title: 'Entrepreneurs', link: '/clients' },
    // { name: 'News and Events', title: 'News and Events', link: '/newsevents' },
    { name: 'About Us', title: 'About Us', link: '/aboutus' },
    { name: 'Contact Us', title: 'Contact Us', link: '/contactus' },
    {
      name: 'Account',
      title: 'Account',
      link: isAuthenticated ? '/myAccount/dashboard' : '/account',
      icon: <AccountCircleIcon />,
    },
    {
      icon: (
        <Badge badgeContent={userId && cartProducts.status == "success" ? cartProducts?.cart.items.length : 0} color="primary">
          <AddShoppingCartIcon />
        </Badge>
      ),
      onClick: () => setDrawerOpen(true),
    }
  ];

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleNavbarToggle = () => {
    setNavbarOpen(!navbarOpen);
  };

  useEffect(() => {
    if (userId) {
      dispatch(getCartProduct(userId)).then((result) => {
        setCart(result?.cart);
      }).catch((error) => {
        console.error(error);
      });
    }
  }, [userId, drawerOpen])

  return (
    <div>
      <nav
        className='navbar navbar-expand-lg'
        style={{
          backgroundColor: navbarOpen && isMobile ? '#000000' : 'transparent',
          opacity: navbarOpen ? '0.8' : '',
          boxShadow: 'none',
        }}
      >
        <div className='container-fluid'>
          <IconButton
            className='navbar-toggler text-light'
            onClick={handleNavbarToggle}
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarResponsive'
            aria-controls='navbarResponsive'
            aria-expanded={navbarOpen}
            aria-label='Toggle navigation'
          >
            <MenuIcon style={{ color: 'white' }} />
          </IconButton>
          <div className='collapse navbar-collapse' id='navbarResponsive'>
            <ul className='navbar-nav ms-auto'>
              {navData.map((item, index) => {
                const isActive = location.pathname === item.link;

                if (item.onClick) {
                  return (
                    <li
                      className={`nav-item ${isActive ? 'active' : ''}`}
                      key={index}
                    >
                      <IconButton
                        onClick={item.onClick}
                        className='nav-link text-light mx-1'
                      >
                        {item.icon}
                      </IconButton>
                    </li>
                  );
                } else {
                  return (
                    <li
                      className={`nav-item ${isActive ? 'active' : ''}`}
                      key={index}
                    >
                      <Link
                        className='nav-link text-light mx-1 text-left d-flex align-items-center'
                        to={item.link}
                        style={{
                          ...(isActive ? activeStyle : {}),
                          ...(hoveredIndex === index ? hoverStyle : {}),
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        {item.icon && (
                          <span className='nav-icon'>{item.icon}</span>
                        )}
                        &nbsp;{item.title}
                      </Link>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>
      </nav>
      <Cart drawerOpen={drawerOpen} handleDrawerClose={handleDrawerClose} />
    </div>
  );
}

export default Navbar;
